import { useQuery } from "@tanstack/react-query";
import { Goal } from "../types/Goal";
import { useMsal } from "@azure/msal-react";
import { BackendAPI } from "../util/Env";

export const goalsKey = "goals"

export const useGoalsQuery = () => {
    const { accounts } = useMsal()
    const { data } = useQuery({
        queryKey: [goalsKey],
        queryFn: async () => {
            const response = await fetch(BackendAPI + '/goals-api.php', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'ownerId': accounts[0].idTokenClaims!.oid!,
                },
            });

            if (!response.ok) {
                throw new Error(`Error fetching goals: ${response.statusText}`);
            }

            return (await response.json()) as Goal[];
        }
    });

    return { goals: data }
}

export const useGoalsById = (id: string | undefined) => {
    const { goals } = useGoalsQuery()
    return { goal: goals?.find(goal => goal.id === id) }
}